import './portal.css';

const app = document.querySelector<HTMLDivElement>('#app');
if (!app) throw new Error('找不到应用容器。');

app.innerHTML = `
  <header class="portal-nav">
    <a class="portal-brand" href="/"><i>造</i><span>造物工坊</span></a>
    <nav aria-label="主导航"><a href="/image-to-3d/">图片生成 3D</a><a href="/cloisonne/">掐丝珐琅</a></nav>
  </header>
  <main class="home">
    <section class="hero">
      <span class="eyebrow">MAKE IT TANGIBLE</span>
      <h1>从一张图，走到手中的作品。</h1>
      <p>为创作与 3D 打印准备的两种图像工具：把物体照片生成立体模型，或把线稿制成可打印的掐丝珐琅作品。</p>
    </section>
    <section class="module-grid" aria-label="工具模块">
      <a class="module-card image-3d" href="/image-to-3d/">
        <div class="card-top"><span class="tag">受限访问 · 云端 AI</span><h2>图片生成 3D</h2><p>上传一张主体清晰的图片，生成可旋转查看的立体模型，并下载 GLB、STL、OBJ。</p></div>
        <span class="orb" aria-hidden="true"></span><span class="card-action">进入图片生成 3D <b>→</b></span>
      </a>
      <a class="module-card cloisonne" href="/cloisonne/">
        <div class="card-top"><span class="tag">本地处理 · 不上传图片</span><h2>掐丝珐琅</h2><p>把线稿或照片整理为可编辑线稿，生成底板和掐丝线条，导出 SVG、STL 与双色 3MF。</p></div>
        <span class="wire-art" aria-hidden="true"></span><span class="card-action">进入掐丝工坊 <b>→</b></span>
      </a>
    </section>
    <p class="home-note">图片生成 3D 只对获得授权的用户开放；模型由受控服务端请求生成，浏览器不会保存 API 密钥。</p>
  </main>
  <footer class="site-footer">造物工坊 · 你的图片在提交生成前仅于当前浏览器处理。</footer>`;
